// extracted by mini-css-extract-plugin
export default {"container":"History_container__cH8sI","div1":"History_div1__2A+61","div2":"History_div2__rQ7RT"};